export default __webpack_public_path__ + "static/Application-56027df9fed24fd8b389c95f86dad706.mp4";